import * as visit from 'unist-util-visit';
import { handleKeywordsOfNode } from './utils';
export var BLOCKQUOTE_PLUGIN_ID = 'mfBlockquote';
export var Blockquote = function () {
  return function (tree) {
    var visitor = function (node) {
      node.type = BLOCKQUOTE_PLUGIN_ID;
      node.alertType = 'info';
      handleKeywordsOfNode(tree, node, function (keyword) {
        switch (keyword) {
          case 'success':
            node.alertType = 'success';
            break;
          case 'warning':
            node.alertType = 'warning';
            break;
          case 'error':
            node.alertType = 'error';
            break;
          case 'loading':
            node.alertType = 'loading';
            break;
          case 'tip':
            node.alertType = 'tip';
            break;
        }
      });
    };
    visit(tree, 'blockquote', visitor);
  };
};